export default __webpack_public_path__ + "static/media/wolfram.0fa19877.png";